import { encKey } from "./config";

export async function getStorageData(key, returnType) {
  try {
    let result = returnType;
    if (key) {
      const localData = localStorage.getItem(key);
      if (localData && localData.length > 0) {
        const CryptoJS = await import("crypto-js");
        const decrData = CryptoJS.AES.decrypt(localData, encKey);
        const decrDataStr = decrData.toString(CryptoJS.enc.Utf8);
        result = JSON.parse(decrDataStr);
      }
    }
    if (key === "favourite") {
      // console.log("favourite-", result);
    }

    return result;
  } catch (error) {
    console.log(error);
    return returnType;
  }
}

export async function setStorageData(key, value) {
  try {
    const data = JSON.stringify(value);
    const AES = await import("crypto-js/aes");
    const encData = AES.encrypt(data, encKey);
    const encDataStr = encData.toString();
    localStorage.setItem(key, encDataStr);
  } catch (error) {
    console.log(error);
  }
}

export function removeStorageData(key) {
  localStorage.removeItem(key);
}
